import { StringHelper } from '@/helper/string'
import useAppState, { ViewType } from '@/composables/ui/ui'

const RELOAD_HASHES = [
  'postId',
  'showSubscribers',
  'respondToPostId',
  'showFollowers',
  'showAllReplies',
  'showUnseenReplies',
  'showMyPosts',
  'showReportedPosts',
  'showSuperLike',
]

export default function useUiFactory() {
  const { postIdToShow, respondToPostId, query, viewType } = useAppState()

  // todo refactor
  const removeRespondHash = () => {
    const hashMap = StringHelper.parseQueryString(
      window.location.hash.substr(1)
    )

    if (hashMap.has('respondToPostId')) {
      hashMap.delete('respondToPostId')
      let resHash = StringHelper.implodeQueryToString(hashMap)

      if (resHash.length > 0) {
        resHash = '#' + resHash
      } else {
        resHash = ' '
      }

      window.location.hash = resHash
    }
    respondToPostId.value = 0
  }

  const removeHash = () => {
    const hashMap = StringHelper.parseQueryString(
      window.location.hash.substr(1)
    )

    if (hashMap.has('postId')) {
      hashMap.delete('postId')

      let resHash = StringHelper.implodeQueryToString(hashMap)

      if (resHash.length > 0) {
        resHash = '#' + resHash
      } else {
        resHash = ' '
      }

      window.location.hash = resHash
    }

    postIdToShow.value = null
  }

  const reloadHash = (reloadHashes: string[] = RELOAD_HASHES) => {
    const hashMap = StringHelper.parseQueryString(
      window.location.hash.substr(1)
    )

    if (reloadHashes.includes('postId')) {
      if (hashMap.has('postId')) {
        const postId: string | undefined = hashMap.get('postId')

        if (typeof postId === 'string') {
          postIdToShow.value = parseInt(postId)
        }
      } else {
        // postIdToShow.value = null
      }
    }
    if (reloadHashes.includes('showSubscribers')) {
      if (hashMap.has('showSubscribers')) {
        const postId: string | undefined = hashMap.get('showSubscribers')
        query.value.showSubscribers = postId === '1'
      } else {
        query.value.showSubscribers = false
      }
    }
    if (reloadHashes.includes('showFollowers')) {
      if (hashMap.has('showFollowers')) {
        const postId: string | undefined = hashMap.get('showFollowers')
        query.value.showFollowers = postId === '1'
      } else {
        query.value.showFollowers = false
      }
    }
    if (reloadHashes.includes('showAllReplies')) {
      if (hashMap.has('showAllReplies')) {
        const postId: string | undefined = hashMap.get('showAllReplies')
        query.value.showAllReplies = postId === '1'
      } else {
        query.value.showAllReplies = false
      }
    }
    if (reloadHashes.includes('showUnseenReplies')) {
      if (hashMap.has('showUnseenReplies')) {
        const postId: string | undefined = hashMap.get('showUnseenReplies')
        query.value.showUnseenReplies = postId === '1'
      } else {
        query.value.showUnseenReplies = false
      }
    }
    if (reloadHashes.includes('showReportedPosts')) {
      if (hashMap.has('showReportedPosts')) {
        const postId: string | undefined = hashMap.get('showReportedPosts')
        query.value.showReportedPosts = postId === '1'
      } else {
        query.value.showReportedPosts = false
      }
    }
    if (reloadHashes.includes('showSuperLike')) {
      if (hashMap.has('showSuperLike')) {
        const postId: string | undefined = hashMap.get('showSuperLike')
        query.value.showSuperLike = postId === '1'
      } else {
        query.value.showSuperLike = false
      }
    }

    if (reloadHashes.includes('showMyPosts')) {
      if (hashMap.has('showMyPosts')) {
        const postId: string | undefined = hashMap.get('showMyPosts')
        query.value.allPosts = postId === '1'
      } else {
        query.value.allPosts = false
      }
    }

    if (reloadHashes.includes('respondToPostId')) {
      if (hashMap.has('respondToPostId')) {
        const postId: string | undefined = hashMap.get('respondToPostId')
        if (
          typeof postId === 'string' &&
          viewType.value === ViewType.DISCUSSION
        ) {
          respondToPostId.value = parseInt(postId)
          postIdToShow.value = respondToPostId.value
        }
      } else {
        // respondToPostId.value = 0
      }
    }
  }

  const updateHash = (id: number) => {
    const hashMap = StringHelper.parseQueryString(
      window.location.hash.substr(1)
    )
    hashMap.set('postId', id.toString())
    window.location.hash = '#' + StringHelper.implodeQueryToString(hashMap)
  }

  return { reloadHash, updateHash, removeHash, removeRespondHash }
}
